/**
* Created by vouill on 3/20/18.
*/

<template>
  <div
    class="main">
    <div class="container">
      <div>
        <div class="title">Nous rejoindre :)</div>
        <div class="action"><a
          rel="noopener noreferrer"
          target="_blank"
          href="https://www.helloasso.com/associations/metis/adhesions/adhesion-metis-2019-2020"><b-button
            class="hvr-buzz-out"
            is-dark
            is-rounded>ADHERER</b-button></a></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.main {
  display: flex;
  justify-content: center;
  background-color: #ff9941;
  background-size: cover;
  background-position: center;
  padding: 8em 0;
}
.container {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.title {
  text-align: center;
}
.action {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
}
</style>

<script>
export default {
  name: "Newsletter",
  props: {},
  components: {},
  data() {
    return {};
  }
};
</script>
